import { Button } from '@/shared/components/ui/button';
import { ErrorFallbackProps } from '@/types/error-fallback-props';
import { CircleX } from 'lucide-react';

export function MiniErrorFallback({ error, resetError }: ErrorFallbackProps) {
  return (
    <div role="alerti" className="flex flex-col items-center size-full justify-center gap-4">
      <CircleX className="text-red-500 size-8" />
      <h2 className="text-lg font-semibold">Ooops, något gick fel 😣</h2>
      <pre>{error.message}</pre>
      <Button onClick={resetError}>Försök igen</Button>
    </div>
  );
}
